<template>
  <div style="height: 100%; overflow: hidden; overflow-x: auto">
    <Vpdf :pdfUrl="src"></Vpdf>
  </div>
</template>

<script>
import Vpdf from "./components/vpdf.vue";
export default {
  components: {
    Vpdf,
  },
  data() {
    return {
        src:this.$route.query.src
    };
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/pdf.vue